<template>
    <div>
        <div class="menu-item-left changeLocationZone" :class="{isTpg:isTpg,isActive:isActive}">
            <div class="main-switcher-container" :class="{isTpg:isTpg}">
                <div class="selectedPlayerHeader switcher-toggle" :class="{isTpg:isTpg,isActive:isActive, noPlayers:(players && players.length < 2)}" @click="toggleSwitcher()">
                    <!-- <div class="onlineLight" :class="{ offlinePlayer: selectedPlayer && selectedPlayer.is_online == false, isTpg:isTpg}">
                            </div> -->
                    <div class="playerAndZone">
                        <div v-if="selectedPlayer">
                            <!-- <div class="changeLocationZone-row-id">{{ selectedPlayer.p_id }}:</div> -->
                            <div v-if="selectedPlayer.isPhysicalPlayer()" :class="[isTpg ? 'playerTypeIconPhysical_tpg' : ' playerTypeIconPhysical_grayv']"></div>
                            <div v-else-if="selectedPlayer.isVirtualPlayer()" :class="[isTpg ? 'playerTypeIconVirtual_tpg' : 'playerTypeIconVirtual_grayv']"></div>
                            <div v-else-if="selectedPlayer.isMobilePlayer()" :class="[isTpg ? 'playerTypeIconMobile_tpg' : 'playerTypeIconMobile_grayv']"></div>
                            <div v-else-if="selectedPlayer.isWSLPlayer()" :class="[isTpg ? 'playerTypeIconWSL_tpg' : 'playerTypeIconWSL_grayv']"></div>
                            <div class="changeLocationZone-row-name">
                                <span v-if="!selectedPlayer.isMobilePlayer()
                                         && !selectedPlayer.isWSLPlayer()"
                                         v-tooltip="{content: selectedPlayer.esTitle + ' - ' +  selectedPlayer.fId()}">{{ selectedPlayer.esTitle + ' - ' + selectedPlayer.fId() }}</span>
                                <span v-else-if="selectedPlayer.isMobilePlayer()"
                                        v-tooltip="{content: selectedPlayer.esTitle + ' - (Mobile)'}">{{ selectedPlayer.esTitle + ' - (Mobile)' }}</span>
                                <span v-else-if="selectedPlayer.isWSLPlayer()"
                                        v-tooltip="{content: selectedPlayer.esTitle + ' - (Web)'}">{{ selectedPlayer.esTitle + ' - (Web)' }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="toggle-arrow" :class="{isTpg:isTpg,isActive:isActive}" v-show="players && players.length > 1">
                        <font-awesome-icon icon="chevron-down" aria-hidden="false"  :class="{ rotateArrow:isActive}" />
                    </div>
                </div>

                <div class="player-selector-container" :class="{isActive:isActive}">
                    <div class="searchrow" v-if="players.length > 0" :class="{isTpg:isTpg}">
                        <input class="search-input" type="search" v-model="searchTerm" :class="{isTpg:isTpg}" placeholder="Find player" ref="searchInput">
                    </div>

                    <div class="changeLocationZone-container" id="custom-scrollbar" :class="{isTpg:isTpg}">

                    <div v-if="players == null" class="empty"></div>
                    <div v-for="player in filteredPlayers.slice((currentPage * itemsPerPage), (currentPage * itemsPerPage)+itemsPerPage)" v-bind:key="player.playerID" @click="selectPlayer(player)">
                        <div v-if="(player.isOnline() && player.currentTrack && player.currentTrack.length)
                                    && (player.fId() == selectedPlayer.fId() && player.esTitle != selectedPlayer.esTitle)
                                    || (player.fId() != selectedPlayer.fId())" class="changeLocationZone-row">
                            <div v-if="player.isPhysicalPlayer()" :class="[isTpg ? 'playerTypeIconPhysical_tpg' : 'playerTypeIconPhysical_grayv']"></div>
                            <div v-else-if="player.isVirtualPlayer()" :class="[isTpg ? 'playerTypeIconVirtual_tpg' : 'playerTypeIconVirtual_grayv']"></div>
                            <div v-else-if="player.isMobilePlayer()" :class="[isTpg ? 'playerTypeIconMobile_tpg' : 'playerTypeIconMobile_grayv']"></div>
                            <div v-else-if="player.isWSLPlayer()" :class="[isTpg ? 'playerTypeIconWSL_tpg' : 'playerTypeIconWSL_grayv']"></div>
                            <span v-if="player.fId()
                                        && !player.isMobilePlayer()
                                        && !player.isWSLPlayer()"
                                        v-tooltip="{content: player.esTitle + ' - ' +  player.fId()}">{{ player.esTitle + ' - ' + player.fId() }}</span>
                            <span v-else-if="player.isMobilePlayer()"
                                        v-tooltip="{content: player.esTitle + ' - (Mobile)'}">{{ player.esTitle + ' - (Mobile)' }}</span>
                            <span v-else-if="player.isWSLPlayer()"
                                        v-tooltip="{content: player.esTitle + ' - (Web)'}">{{ player.esTitle + ' - (Web)' }}</span>
                        </div>
                    </div>
                    <div v-if="players && (filteredPlayers.length > itemsPerPage)" class="pagination-container">
                        <div class="pagination">
                            <span>
                                        {{currentPage * itemsPerPage + 1 }} -
                                        <span v-if="((currentPage * itemsPerPage) + itemsPerPage) < filteredPlayers.length">{{ (currentPage * itemsPerPage) + itemsPerPage }}</span>
                            <span v-else>{{ filteredPlayers.length }}</span> of {{ filteredPlayers.length }}
                            </span>
                            &nbsp;&nbsp;
                            <span v-if="currentPage >= 1" class="prev-next-button" @click="goToPage(currentPage - 1)"><i class="fas fa-chevron-left"></i></span>
                            <span v-else class="prev-next-button disabled"><i class="fas fa-chevron-left"></i></span>
                            <span v-if="(filteredPlayers.length > (itemsPerPage*(currentPage+1)))" class="prev-next-button" @click="goToPage(currentPage + 1)"><i class="fas fa-chevron-right"></i></span>
                            <span v-else class="prev-next-button disabled"><i class="fas fa-chevron-right"></i></span>
                        </div>
                    </div>

                    </div>
                </div>
                <div v-if="players == null" class="empty"></div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      filteredPlayers: [],
      searchTerm: '',
      currentPage: 0,
      itemsPerPage: 1000,
      isActive: false,
    };
  },
  props: ['selected-player', 'players', 'is-tpg', 'is-loading-remaining-players'],
  mounted() {
    this.filteredPlayers = this.players;
  },
  methods: {
    toggleSwitcher() {
      if (this.players.length < 2) {
        return;
      }
      this.searchTerm = '';
      this.isActive = !this.isActive;
    },
    goToPage(page) {
      this.currentPage = page;
    },
    /**
     * Emits new player to MainMenu.vue.
     *
     * @param object player
     * @emit player
     */
    selectPlayer(player) {
      if (player) {
        this.$emit('changePlayerClicked', player);
      }
      this.searchTerm = '';
      this.isActive = false;
    },
    /**
     * Checks if selectedPlayer location_zone_player_data timestamp is less than 15 minutes ago.
     *
     * @param object player
     * @return bool
     */
    playerIsOffline(player) {
      if (!player || !player.last_checkin) {
        return true;
      }

      const fifteenMinutes = 15 * 60;
      const lastCheckIn = player.last_checkin;
      const unixTimeStamp = Math.round(+new Date() / 1000);

      if ((unixTimeStamp - lastCheckIn) > fifteenMinutes) {
        return true;
      }
      return false;
    },
    searchPlayers() {
      if (!this.players) return;

      const matchedObjects = [];
      // T239 (01-12-2002), T369: Modified (05-20-2022)
      if (this.players && this.players.length > 0) {
          Object.keys(this.players).forEach(key => {
              const searchExpression = this.searchTerm.toLowerCase();
              if (this.players[key].esTitle && this.players[key].esTitle.toLowerCase().includes(searchExpression)
                  || this.players[key].fId() && this.players[key].fId().toString().includes(searchExpression)
                  || this.players[key].storeNumber && this.players[key].storeNumber.toLowerCase().includes(searchExpression)
              ) {
              matchedObjects.push(this.players[key]);
              }
          });
      }
      return matchedObjects;
    },
  },
  computed: {
    // selectedPlayerID() {
    //   if (this.selectedPlayer && this.selectedPlayer.playerId/*p_id*/) {
    //     return this.selectedPlayer.playerId/*p_id*/;
    //   }

    //   return null;
    // },
  },
  watch: {
    searchTerm() {
      // If search empty, show all players
      if (this.searchTerm.length < 1) {
        this.filteredPlayers = this.players;
        return;
      }

      this.filteredPlayers = this.searchPlayers();
    },
    players() {
      this.filteredPlayers = this.players;
    },
    isActive() {
      this.$nextTick(() => {
        if (this.$refs.searchInput) {
          this.$refs.searchInput.focus();
        }
      });
    },
  },

};

</script>

<style scoped>
.changeLocationZone {
    padding-bottom: 10px;
    max-height: 330px;
    padding-bottom: 20px;
}

.changeLocationZone-container {
    padding-top: 5px;
    margin-top: -5px;
    max-height: 180px;
    overflow-y: auto;
    clear: left;
}

.changeLocationZone-row {
    /* border-bottom: 1px solid rgb(156, 156, 156); */
    height: 29px;/*30px;*/ /*44px;*/
    font-size: 12px;
    line-height: 44px;
    margin-right: 20px;
    transition: 0.3s;
    cursor: pointer;
    clear: both;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    padding-left: 0px;
}

.changeLocationZone-row.isTpg {
    border-bottom: 1px solid #ccc;
}

/*.changeLocationZone-row:nth-child(n+1) {
    border-bottom: 0px;
}*/

.changeLocationZone-row:last-child {
    border-bottom: 0px;
}

.changeLocationZone-row:hover {
    /* color: rgba(0, 0, 0, 1); */
    opacity: .7;
}
.changeLocationZone-row-id {
    width:42px;
    float:left;
    text-align: left;
}
.changeLocationZone-row-name {
    width:calc(98% - 42px);
    float:left;
    text-align: left;
     overflow: hidden;
}
.onlineLight {
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background: yellow;
    float: left;
    margin-top: 27px;
    margin-right: 17px;
}

.onlineLight.isTpg {
    background: #00c996;
}

.offlinePlayer {
    background: #ccc;
}

.playerID {
    width: 70px;
    float: right;
    font-size: 13px;
    color: white;
    text-align: right;
}

.playerID.isTpg {
    color: black;
}

.playerAndZone {
    float: left;
    width: calc(100% - 24px);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-weight: normal;
}

.playerTypeIconPhysical_tpg {
    height: 16px;
    width: 16px;
    background-image: url("../../../assets/images/whats-on/gray-v_ico_01_physical_black.svg");
    float: left;
    margin-top: 13px;
    margin-right: 10px;
}
.playerTypeIconVirtual_tpg {
    height: 16px;
    width: 16px;
    background-image: url("../../../assets/images/whats-on/gray-v_ico_02_virtual_black.svg");
    float: left;
    margin-top: 13px;
    margin-right: 10px;
}
.playerTypeIconMobile_tpg {
    height: 16px;
    width: 16px;
    background-image: url("../../../assets/images/whats-on/gray-v_ico_03_in-store_black.svg");
    float: left;
    margin-top: 13px;
    margin-right: 10px;
}
.playerTypeIconWSL_tpg {
    height: 16px;
    width: 16px;
    background-image: url("../../../assets/images/whats-on/gray-v_ico_04_web_black.svg");
    float: left;
    margin-top: 13px;
    margin-right: 10px;
}

.playerTypeIconPhysical_grayv {
    height: 16px;
    width: 16px;
    background-image: url("../../../assets/images/whats-on/gray-v_ico_01_physical_yellow.svg");
    float: left;
    margin-top: 13px;
    margin-right: 10px;
}
.playerTypeIconVirtual_grayv {
    height: 16px;
    width: 16px;
    background-image: url("../../../assets/images/whats-on/gray-v_ico_02_virtual_yellow.svg");
    float: left;
    margin-top: 13px;
    margin-right: 10px;
}
.playerTypeIconMobile_grayv {
    height: 16px;
    width: 16px;
    background-image: url("../../../assets/images/whats-on/gray-v_ico_03_in-store_yellow.svg");
    float: left;
    margin-top: 13px;
    margin-right: 10px;
}
.playerTypeIconWSL_grayv {
    height: 16px;
    width: 16px;
    background-image: url("../../../assets/images/whats-on/gray-v_ico_04_web_yellow.svg");
    float: left;
    margin-top: 13px;
    margin-right: 10px;
}

.spinner {
    margin: 10px auto;
    width: 55px;
    height: 35px;
    text-align: center;
    font-size: 8px;
    margin-top: 1px;
    margin-bottom: -1px;
}

.spinner>div {
    background-color: #fff;
    height: 40%;
    width: 8px;
    display: inline-block;
    -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
    animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.spinner.black>div {
    background-color: rgb(179, 179, 179);
}

.spinner .rect2 {
    -webkit-animation-delay: -1.1s;
    animation-delay: -1.1s;
}

.spinner .rect3 {
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
}

.spinner .rect4 {
    -webkit-animation-delay: -0.9s;
    animation-delay: -0.9s;
}

.spinner .rect5 {
    -webkit-animation-delay: -0.8s;
    animation-delay: -0.8s;
}

.pagination {
    width: 100%;
    float: right;
    text-align: right;
    font-size: 12px;
    margin-right: 15px;
}

.prev-next-button {
    cursor: pointer;
    padding: 2px 8px 2px 8px;
    border: 1px solid white;
    border-radius: 3px;
    color: white;
    font-size: 12px;
}

.main-switcher-container {
    background: rgba(50, 50, 50, 1);
    border-radius: 5px;
    position: relative;
}

.main-switcher-container.isTpg {
    background: rgba(212, 212, 212, 1);
}

.changeLocationZone.isActive .main-switcher-container {
    border-radius: 5px 5px 0 0;
}

.player-selector-container {
    display: none;
    border: 0px;
    padding: 0px 7px 7px 7px;
    background-color: rgba(50, 50, 50, 1);
    position: absolute;
    width: 100%;
    min-height: 215px;
    z-index: 100;
}

.player-selector-container.isActive {
    display: block;
    /* border-bottom: 1px solid #000;
    border-left: 1px solid #000;
    border-right: 1px solid #000; */
    /* background: rgba(0,0,0,0.3);
    border-radius: 3px; */
    /* box-shadow: 0px 3px 15px rgba(0,0,0,0.2); */
}

.main-switcher-container.isTpg .player-selector-container {
  background: rgba(212, 212, 212, 1);
}

.switcher-toggle {
    cursor: pointer;
    height: 40px;
    padding-left: 7px;
    line-height: 40px;
    /* font-size:20px; */
    width: 100%;
    opacity: 1;
    /* box-shadow:  2px 2px 5px rgba(0,0,0,0.4); */
}

.switcher-toggle.isActive:hover {
    /* color:black; */
    /* border: 0px 0px 0px; */
    /* border-top: 1px solid #000;
    border-left: 1px solid #000;*/
    box-shadow: 0px 0px 0px;
}

.switcher-toggle:hover {
    opacity: .9;
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
}
.switcher-toggle.isTpg:hover {
    box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.2);
}
.switcher-toggle.noPlayers {
    cursor:default;
    box-shadow: 0px 0px 0px;
}

.rotateArrow {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
}

.toggle-arrow {
    color: white;
    float: right;
    margin-right: 10px;
    margin-top: 0px;
    font-size: 12px;
    max-width: 24px;
}

.toggle-arrow.isTpg {
    color: black;
}

.searchrow {
    width: 100%;
    margin: 0 auto;
    margin-bottom: 0px;
    margin-top: 0px;
    padding-bottom: 5px;
    clear: both;
    float:left;
    border:0px;
}

::-webkit-input-placeholder {
    color: #a9a9a9;
    padding-left: 2px;
    padding-left: 2px;
}

.selectedPlayerHeader {
    color: white;
}

.selectedPlayerHeader.isTpg {
    color: black;
}

.selectedPlayerHeader.isActive.isTpg {
    color: black;
}

.selectedPlayerHeader.isActive {
    color: #efefef;
}

.selectedRow {
    font-weight: normal;
}
</style>
